import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CKEditor4 } from 'ckeditor4-angular';
import { CaseView } from '../../models/caseview.model';
import { DomSanitizer } from '@angular/platform-browser';

export interface DialogData {
  from: string;
  selectedDraft: any;
  case: CaseView;
  templateId: any;
  readonly: Boolean;
  title: any;
  tmpltId: any;
  flag: boolean;
  content: any;
  placeHolderMap: any;
  showSubmit: Boolean;
}

export interface RESULTVO {
  remarks: string;
  templateId: number;
  footerTmplt: string;
  headerTmplt: string;
}
export interface PREPARERESPONSE {
  data: {
    draftTitle: string;
    resultVO: RESULTVO;
  };
}
@Component({
  selector: 'app-create-draft',
  templateUrl: './create-draft.component.html',
  styleUrls: ['./create-draft.component.scss'],
})
export class CreateDraftComponent implements OnInit, OnDestroy {
  draftTitle: any;
  draftId: number;
  mpgId: number;
  updatedDraftBase64: string;
  public editorConfig = {
    toolbar: [
      ['Source'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['Bold', 'Italic'],
      ['Undo', 'Redo'],
      ['base64image'],
      ['PageBreak'],
      ['Link'],
      ['TextColor', 'BGColor'],
      ['Table'],
      [
        'heading',
        '|',
        'alignment:left',
        'alignment:right',
        'alignment:center',
        'alignment:justify',
      ],
      ['About'],
    ],
    height: '900px',
    width: '100%',
    removePlugins: 'scayt',
    disableNativeSpellChecker: false,
    removeButtons: 'SCAYT',
    allowedContent: true,
  };
  from: string;
  data = '';
  draftBase64: string;
  caseDetails: CaseView;
  templateId: any;
  draftData: unknown;
  selectedDraft: any;
  showAttachmentFlag = false;
  currentType = 'pdf';
  previewSrc = null;
  onlyPreview = false;

  content: any;
  tmpltId: any;
  title: any;
  placeHolderMap: any;
  readOnlyCkeditor: Boolean = false;
  showSubmit: Boolean = true;

  postData: any = {
    tmpltId: null,
    placeHolderMap: null,
  };

  isHeader = true;
  isContent = true;
  isFooter = true;
  headerData = null;
  contentData = null;
  footerData = null;
  contentTemplate;
  headerTemplate;
  footerTemplate;
  appId;
  categoryId;
  showTemplateSelection = false;
  fullsection: any = true;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
    public dialogRef: MatDialogRef<CreateDraftComponent>,
    private sanitize: DomSanitizer
  ) {
    this.from = dialogData.from;
    this.selectedDraft = dialogData.selectedDraft;
    this.caseDetails = dialogData.case;
    this.appId = this.caseDetails.appTypeId;
    this.templateId = dialogData.templateId;
    this.content = dialogData.content;
    this.tmpltId = dialogData.tmpltId;
    this.placeHolderMap = dialogData.placeHolderMap;
    this.title = dialogData.title;
    this.showSubmit = dialogData.showSubmit ? dialogData.showSubmit : true;
    this.readOnlyCkeditor = dialogData.readonly ? dialogData.readonly : false;
  }
  previewAttachID = null;
  ngOnInit(): void {
    this.editorConfig = {
      toolbar: [
        ['Source'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['Bold', 'Italic'],
        ['Undo', 'Redo'],
        ['About'],
      ],
      height: '400px',
      width: '100%',
      removePlugins: 'scayt',
      disableNativeSpellChecker: false,
      removeButtons: 'SCAYT',
      allowedContent: true,
    };
    if (!this.dialogData?.flag) {
      if (this.from == 'prepare') {
        this.showAttachmentFlag = false;
        this.onlyPreview = false;
        this.prepareDraft(this.caseDetails, this.templateId);
      } else if (this.from == 'view') {
        if (this.selectedDraft) {
          this.getviewData();
          if (this.dialogData?.selectedDraft?.draftStatus == '970') {
            this.showAttachmentFlag = true;
            this.onlyPreview = true;
            this.preview();
          } else {
            this.showAttachmentFlag = false;
            this.onlyPreview = false;
          }
        }
      } else {
        console.error('from undefined');
      }
    } else {
      if (this.content?.length > 0) {
        this.data = this.dialogData.content;
        this.draftData = this.data;
        this.contentData = this.data;
      } else {
        this.postData.tmpltId = this.dialogData.tmpltId;
        this.postData.placeHolderMap = this.dialogData.placeHolderMap;

        this.http
          .post<any>('/admin/template-content', this.postData)
          .subscribe((res: any) => {
            this.data = res?.data;
            this.draftData = this.data;
            this.contentData = this.data;
          });
      }
    }
    document.body.style.position = 'relative';
  }
  ngOnDestroy(): void {
    document.body.style.position = '';
  }
  getviewData(): void {
    let draft_Id = this.selectedDraft.draftId;
    let params = new HttpParams();
    params = params.append('draftId', draft_Id);
    params = params.append('isListFlag', true);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    this.http
      .get('/case-mgmnt/preview-draft', { headers: headers, params: params })
      .subscribe((res: any) => {
        this.contentData = atob(res?.data?.fileBytes);
        this.headerData = atob(res?.data?.headerFileBytes);
        this.footerData = atob(res?.data?.footerFileBytes);
        this.contentTemplate = atob(res?.data?.fileBytes);
        this.data = res?.data?.strContent;
        this.headerTemplate = atob(res?.data?.headerFileBytes);
        this.footerTemplate = atob(res?.data?.footerFileBytes);
      });
  }

  prepareDraft(caseDetails, templateId): void {
    const params = new HttpParams()
      .set('draftMpgId', templateId.optionValue)
      .set('refId', caseDetails.docId)
      .set('appId', caseDetails.appTypeId)
      .set('subjectId', caseDetails.subjectId)
      .set('jobId', caseDetails.jobId)
      .set('draftTitle', templateId.optionText);

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let dataForPost = {
      draftMpgId: templateId.optionValue,
      refId: caseDetails.docId,
      appId: caseDetails.appTypeId,
      subjectId: caseDetails.subjectId,
      jobId: caseDetails.jobId,
      draftTitle: templateId.optionText,
    };
    this.http;
    this.http
      .post('/case-mgmnt/prepare-draft', dataForPost, {
        headers: headers,
      })
      .subscribe(
        (res: PREPARERESPONSE) => {
          this.draftTitle = res.data.draftTitle;
          this.draftBase64 = res.data.resultVO.remarks;
          this.updatedDraftBase64 = this.draftBase64;
          this.contentData = this.data;
          this.headerData = res?.data?.resultVO?.headerTmplt
            ? res?.data?.resultVO?.headerTmplt
            : '';
          this.footerData = res?.data?.resultVO?.footerTmplt
            ? res?.data?.resultVO?.footerTmplt
            : '';
          this.data = this.headerData + this.contentData + this.footerData;
          this.headerTemplate = this?.headerData;
          this.contentTemplate = this?.data;
          this.footerTemplate = this?.footerData;
        },
        (err) => {
          console.log(err);
        }
      );
  }
  onReady(): void {
    console.log();
  }

  onBlur(): void {
    console.log();
  }

  onChange(e: CKEditor4.EventInfo): void {
    this.updatedDraftBase64 = btoa(e.editor.getData());
    this.data = e.editor.getData();
    this.contentData = this.data;
  }
  save(fromActon): void {
    let data;
    if (this.from == 'prepare') {
      data = {
        draftId: this.draftId ? this.draftId : -1,
        refId: this.caseDetails.docId,
        appId: this.caseDetails.appTypeId,
        draftTitle: this.draftTitle,
        draftMpgId: this.templateId?.optionValue?.split('~')[0],
        jobId: this.caseDetails.jobId,
        draftContentData: btoa(unescape(encodeURIComponent(this.data))),
        draftHeader: null,
        draftFooter: null,
        mpgId: this.mpgId ? this.mpgId : -1,
      };
    } else if (this.from == 'view') {
      data = {
        draftId: this.selectedDraft.draftId,
        refId: this.caseDetails.docId,
        appId: this.caseDetails.appTypeId,
        draftTitle: this.draftTitle,
        draftMpgId: this.selectedDraft.draftMpgId,
        jobId: this.caseDetails.jobId,
        draftContentData: btoa(unescape(encodeURIComponent(this.data))),
        draftHeader: null,
        draftFooter: null,
        mpgId: this.selectedDraft.mpgId,
      };
    }

    this.http.post('/case-mgmnt/save-draft', data).subscribe(
      (res: any) => {
        if (this.from == 'prepare') {
          this.selectedDraft.draftId = res?.data?.draftId;
          this.draftId = res.data.draftId;
          this.mpgId = res.data.mpgId;
          this.from = 'view';
        }
        if (fromActon == 'save&close') {
          this.dialogRef.close('success');
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  preview() {
    let draft_Id = -1;
    if (this.from == 'prepare') {
      draft_Id = this.draftId ? this.draftId : -1;
    } else if (this.from == 'view') {
      draft_Id = this.selectedDraft.draftId;
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let params = new HttpParams();
    params = params.append('draftId', draft_Id);
    params = params.append('isListFlag', false);
    this.http
      .get('/case-mgmnt/preview-draft', { headers: headers, params: params })
      .subscribe((res) => {
        const restemp: any = res;
        this.showAttachmentFlag = true;
        this.previewSrc = this.sanitize.bypassSecurityTrustResourceUrl(
          'data:' + 'application/pdf' + ';base64,' + restemp?.data?.fileBytes
        );
      });
  }
  closeAttachment() {
    this.data = atob(this.draftBase64);
    this.contentData = this.data;
    this.showAttachmentFlag = false;
  }
  approve(): void {
    //
    let draft_Id = -1;
    if (this.from == 'prepare') {
      draft_Id = this.draftId ? this.draftId : -1;
    } else if (this.from == 'view') {
      draft_Id = this.selectedDraft.draftId;
    }
    const input = {
      ServiceID: '2413',
      refId: this.selectedDraft.refId,
      appId: '1',
      draftId: draft_Id,
      mvmntPk: -1,
    };
    this.http.post('/case-mgmnt/approve-draft', input).subscribe(
      (res) => {
        this.dialogRef.close('success');
      },
      (err) => {
        //
        console.log(err);
      }
    );
  }
  submit() {
    this.contentData = this.data;
    this.dialogRef.close(this.data);
  }
  getCKData(event) {
    this.headerTemplate = event?.headerData;
    this.contentTemplate = event?.contentData;
    this.footerTemplate = event?.footerData;
  }
}
